// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3VqkM","requiredAsterisk":"Info_requiredAsterisk__2NzPZ"};